import * as Redux from "redux";
import { State } from "../model/State";

import * as ChangeProcessListPageActions from "../actions/ChangeProcessListPage";
import * as ProcessListActions from "../actions/ProcessListActions";

import { toggleVisibleColumns } from "../reducers/ListStateReducer";

import { DispatchType } from "../../shared/utilities";
import { setRowsPerPage } from "../model/RowsPerPage";
import { setVisibleColumnsToStore } from "../model/VisibleColumnsStore";
import { setCountsTimeLimitDaysToStore } from "processList/model/CountsTimeLimitDaysStore";

export const persistListSettingsMiddleware: any =
    (store: Redux.Store<State>) =>
        (next: DispatchType<State>) =>
            (action: Redux.Action) => {
                if (action) {
                    switch (action.type) {
                        case ProcessListActions.TOGGLE_VISIBLE_PROCESS_LIST_COLUMN: {
                            const toggleColumnAction = action as ProcessListActions.ToggleVisibleProcessListColumn;
                            const currentState = store.getState();
                            setVisibleColumnsToStore(
                                currentState.isSubprocessList,
                                toggleVisibleColumns(toggleColumnAction.column, currentState.listState.visibleColumns));
                            break;
                        }
                        case ProcessListActions.CHANGE_COUNTS_TIME_LIMIT: {
                            const countsTimeLimitDays = action as ProcessListActions.ChangeCountsTimeLimitAction;
                            setCountsTimeLimitDaysToStore(countsTimeLimitDays.newLimitDays);
                            break;
                        }
                        case ChangeProcessListPageActions.CHANGE_PROCESS_LIST_ROWS_PER_PAGE: {
                            const changeRowsPerPage = action as ChangeProcessListPageActions.ChangeProcessListRowsPerPageAction;
                            setRowsPerPage(changeRowsPerPage.newRowsPerPage);
                            break;
                        }
                    }
                    next(action);
                }
            };
